import { ApiClient } from 'api/RestClient';
import { doPost } from 'util/AxiosUtil';

// 입사지원
export const insertCareer = async (data: FormData) => {
  return doPost<boolean>(ApiClient, '/api/contact/insertCareer', data).then((res) => res.data);
};
